import { number, alpha } from '../numbers/index.mjs';
import { sanitize, clamp } from '../utils.mjs';
import { isColorString, splitColor } from './utils.mjs';
const clampRgbUnit = clamp(0, 255);
const rgbUnit = Object.assign(Object.assign({}, number), {
  transform: v => Math.round(clampRgbUnit(v))
});
const rgba = {
  test: isColorString('rgb', 'red'),
  parse: splitColor('red', 'green', 'blue'),
  transform: _ref => {
    let {
      red,
      green,
      blue,
      alpha: alpha$1 = 1
    } = _ref;
    return 'rgba(' + rgbUnit.transform(red) + ', ' + rgbUnit.transform(green) + ', ' + rgbUnit.transform(blue) + ', ' + sanitize(alpha.transform(alpha$1)) + ')';
  }
};
export { rgbUnit, rgba };